module.exports = __webpack_public_path__ + "img/google.d7335a78.png";